if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11');
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window;
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this);
		}
	};
}

const prevArrow = `<button type="button" class="slick-prev" aria-label="Prev"><svg width="10" height="20" viewBox="0 0 10 20" fill="none" stroke="currentColor" stroke-width="1"><path d="M 9 1 L 1 10 L 9 19" /></svg><span>Prev</span></button>`;
const nextArrow = `<button type="button" class="slick-next" aria-label="Next"><span>Next</span><svg width="10" height="20" viewBox="0 0 10 20" fill="none" stroke="currentColor" stroke-width="1"><path d="M 1 1 L 9 10 L 1 19" /></svg></button>`;
const slickOps = {
	accessibility: false,
	prevArrow: prevArrow,
	nextArrow: nextArrow,
};

function validateCMSAlert() {
	if (typeof window.MutationObserver !== 'undefined') {
		const bodyObserver = new MutationObserver((mutationList, observer) => {
			const bodyClasses = document.body.classList;
			const bodyMargin = parseInt(document.querySelector('#header').style.top) > 0 ? document.querySelector('#header').style.top : 0;

			if (bodyClasses.contains('alert_open')) {
				document.body.style.marginTop = bodyMargin;
				observer.disconnect();
			}
		});

		bodyObserver.observe(document.body, {
			attributes: true,
			attributeFilter: ['class'],
			childList: false,
			characterData: false,
		});
	}
}

(function () {
	validateCMSAlert();

	// VIDEO TOGGLE BTNs
	document.querySelectorAll('[data-video_toggle]').forEach((btn) => {
		const targetVideo = document.getElementById(btn.dataset.video_toggle);
		btn.addEventListener('click', () => {
			if (targetVideo && targetVideo.tagName === 'VIDEO') {
				if (targetVideo.paused) {
					targetVideo.play();
				} else {
					targetVideo.pause();
				}

				btn.classList.toggle('playing', !targetVideo.paused);
			}
		});
	});

	// CUSTOM SELECT
	document.querySelectorAll('[data-custom_select]').forEach((select) => {
		const currentField = select.querySelector('input');

		if (currentField) {
			currentField.addEventListener('click', () => select.classList.toggle('active'));
		}

		select.querySelectorAll('li').forEach((li) => {
			li.addEventListener('click', () => {
				if (currentField) {
					currentField.value = li.dataset.value;
				}

				select.querySelectorAll('li').forEach((l) => l.classList.remove('active'));
				li.classList.add('active');

				select.classList.remove('active');
			});
		});
	});

	if (document.getElementById('terms_btn')) {
		let btnTerms = document.getElementById('terms_btn');
		let termsInfo = document.getElementById('specialsTerms');
		let termsInfoHeight = termsInfo.getElementsByClassName('text')[0].clientHeight;
		btnTerms.addEventListener('click', function (e) {
			e.preventDefault();
			termsInfo.classList.toggle('open');
			if (!this.classList.contains('active')) {
				this.classList.add('active');
				termsInfo.style.height = termsInfoHeight + 'px';
			} else {
				this.classList.remove('active');
				termsInfo.style.height = '0px';
			}
		});
	}

	const primaryNav = document.querySelector(".sub-menu");
	const primaryNavList = primaryNav.firstElementChild;

	primaryNavList.removeAttribute("id"); 
	const mid = Math.ceil((primaryNavList.children.length + 1) / 2);
	const ul = document.createElement("ul"); 
	ul.className = "header__section flex-box a-center";
	const primaryNavGroups = [ 
		[...primaryNavList.children].slice(0, mid), 
		[...primaryNavList.children].slice(mid) 
	];
	primaryNavList.remove();
	primaryNavGroups.forEach(group => { 
		const clonedList = primaryNavList.cloneNode(false); 
		clonedList.append(...group);
		const li = document.createElement("li"); 
		li.classList.add("header__even"); 
		li.append(clonedList);
		ul.append(li); 
	}); 
	primaryNav.append(ul);

	// ACCORDION TOGGLE
	document.querySelectorAll('.accordion').forEach((accordion) => {
		accordion.querySelectorAll('.accordion_head').forEach((itemHead) => {
			itemHead.addEventListener('click', (e) => {
				accordion.querySelectorAll('.accordion_item').forEach((item) => {
					if (itemHead.parentNode !== item) item.classList.remove('active');
				});
				itemHead.parentNode.classList.toggle('active');
			});
		});
	});

	// TOGGLE FADE ON CLICK
	document.querySelectorAll('[data-toggle_fade]').forEach((btn) => {
		const target = document.querySelector(btn.getAttribute('href'));
		if (target) {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				btn.classList.toggle('active');
				target.classList.toggle('active');
			});
		}
	});

	// INPUT TYPE FILE
	document.querySelectorAll('.form-module__field.fileupload').forEach((field) => {
		const fileInput = field.querySelector('input[type="file"]');
		const textInput = field.querySelector('input[type="text"]');
		const rmLink = field.querySelector('.rmFile');

		if (fileInput) {
			fileInput.addEventListener('change', (e) => {
				field.classList.add('withFile');
				if (textInput) textInput.classList.remove('hidden');
			});
		}

		if (rmLink) {
			rmLink.addEventListener('click', () => {
				field.classList.remove('withFile');
				if (textInput) textInput.classList.add('hidden');
			});
		}
	});

	// WRAP MODULE TABLES
	document.querySelectorAll('.tableModule table').forEach((table) => {
		const tableWrapper = document.createElement('div');
		tableWrapper.classList.add('tableModule_wrap');
		table.parentNode.insertBefore(tableWrapper, table);
		tableWrapper.appendChild(table);
	});

	// MOBILE TABLE TO DROPDOWNS
	const tablesResp = document.querySelectorAll('.tableModule table');
	if (tablesResp.length) {
		tablesResp.forEach((tablei) => {
			var tableresponsive = document.createElement('div');
			tableresponsive.classList.add('tableHold');
			tablei.parentNode.insertBefore(tableresponsive, tablei);
			tableresponsive.append(tablei);
			const ths = tablei.querySelectorAll('tr:first-child > *');
			tablei.querySelectorAll('tr + tr').forEach((row) => {
				const tds = row.querySelectorAll('td');
				let i = 0;
				for (i; i < tds.length; i++) {
					tds[i].setAttribute('data-label', ths[i].textContent);
				}
			});
			const rowHeads = tablei.querySelectorAll('tr td:first-child');
			rowHeads.forEach((ele) => {
				ele.addEventListener('click', (ev) => {
					ele.closest('tr').classList.toggle('active');
				});
			});
		});
	}

	// LOCATION CATEGORIES FILTER
	document.querySelectorAll('.locationMod').forEach((mod) => {
		mod.querySelectorAll('[data-showpins]').forEach((btn) => {
			btn.addEventListener('click', () => {
				mod.querySelectorAll('[data-showpins]').forEach((b) => b.classList.remove('active'));
				btn.classList.add('active');

				mod.querySelectorAll('.locationMod_pin').forEach((pin) => pin.classList.remove('active'));
				if (btn.dataset.showpins === 'all') {
					mod.querySelectorAll(`.locationMod_pin`).forEach((pin) => pin.classList.add('active'));
				} else {
					mod.querySelectorAll(`.locationMod_pin[data-tag="${btn.dataset.showpins}"]`).forEach((pin) => pin.classList.add('active'));
				}
			});
		});
	});

	// TOP REASONS TOGGLE
	document.querySelectorAll('.topReasons').forEach((mod) => {
		const $reasonsSlider = $('.topReasons_list', mod);

		$('[data-reason]', mod).mouseenter(function (e) {
			const target = $(this).data('reason') ? parseInt($(this).data('reason')) : 0;

			$reasonsSlider.addClass('active');
			$reasonsSlider.slick('slickGoTo', target);
		});

		$('.topReasons_box', mod).mouseleave(function () {
			$reasonsSlider.removeClass('active');
		});
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach((e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e));

	// FANCYBOX SETTINGS
	// $.fancybox.defaults.touch = false;
	// $.fancybox.defaults.btnTpl.smallBtn = `
    //     <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
    //         <svg fill="none" stroke="currentColor" stroke-width="1" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg"><line x1="1" y1="1" x2="17" y2="17" /><line x1="17" y1="1" x2="1" y2="17" /></svg>
    //     </button>
    // `;

	// Slick Slider with current slide number
	$('[data-slick_showIndex]').each((i, el) => {
		let currentIndex = 1;

		$(el).on('init', (e, s) => {
			console.log(s.slideCount);
			if (s.options.arrows) {
				$(s.options.appendArrows).append(`<div class="slick-current_index"><span>${currentIndex}</span>/${s.slideCount}</div>`);
			}
		});

		$(el).on('beforeChange', (e, s, c, n) => {
			currentIndex = n + 1;
			if (s.options.arrows) {
				$('.slick-current_index span', s.options.appendArrows).text(`${currentIndex}`);
			}
		});
	});

	$('.sym-slides').slick(slickOps);

	$('[data-slick-prev]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickPrev');
	});

	$('[data-slick-next]').click(function () {
		const $curSlider = $(this).data('target') ? $($(this).data('target')) : $(this).closest('.sym-slides');
		$curSlider.slick('slickNext');
	});

	// ADD LineBreak In FAQ Page TITLE
	function insertLineBreakBeforeAmpersand(str, character) {
		if (window.innerWidth <= 768) { // only do this on mobile screens
			const ampIndex = str.indexOf(character);
			if (ampIndex !== -1) {
				const modifiedStr = str.substring(0, ampIndex) + '\n' + str.substring(ampIndex);
				return modifiedStr;
			}
		}
		return str;
	}

	if( document.getElementById('default') &&
			document.getElementById('default').classList.contains('page-70544') ) {

		let titleHTML = document.querySelector('.introContent h1.titles');
		let titleText = titleHTML.innerText;
		let newFaqTitle = insertLineBreakBeforeAmpersand(titleText, '&');

		titleHTML.innerText = newFaqTitle;
}

	if( document.getElementById('form_id-1769')){
		let submitButton = document.getElementById('form_id-1769').querySelector('button[type="submit"]');
		submitButton.setAttribute('aria-label', 'submit form')
		console.log( submitButton);
	}

	if(document.querySelector('.lbw_widget')) {
		let submitButton = document.querySelector('.lbw_widget').querySelector('button[type="submit"]');
		let offerName = document.querySelector('.lbw_topContent-titles .titles').textContent;
		console.log(offerName);
		submitButton.textContent = 'Book Now';
		submitButton.setAttribute('aria-label', `book now ${ offerName }`)
	}

	if(document.querySelector('.signup-btn ')) {
		let submitButton = document.querySelector('.signup-btn ');
		submitButton.setAttribute('aria-label', 'Subscribe')
	}

	if(document.querySelector('#termly-consent-preferences')) {
		let button = document.querySelector('#termly-consent-preferences');
		button.setAttribute('aria-label', 'Consent Preferences for cookies')
	}

	
})();
